import React, { useMemo } from 'react';
import { Container, Sprite, Text } from '@pixi/react';
import { getGameImages } from '../../../core/helpers/getGameImages';
import { applicationStore } from '../../../store/applicationStore';

function ReconnectPopup() {
  const { reconnectIcon } = useMemo(() => {
    return getGameImages();
  }, []);
  return (
    <Container>
      <Sprite texture={reconnectIcon} x={157} y={41} />
      <Text
        x={186}
        y={112}
        anchor={0.5}
        text={applicationStore.canvasTranslationKeys.PLEASE_WAIT}
        style={{
          _fontSize: 16,
          _fontWeight: 500,
          _fontFamily: 'poppinsMedium',
          _fill: '#FFFFFF',
          align: 'center',
          _wordWrap: true,
          _wordWrapWidth: 206,
        }}
        resolution={2}
      />
      <Text
        x={186}
        y={139}
        anchor={0.5}
        text={applicationStore.canvasTranslationKeys.RECONNECTING}
        style={{
          _fontSize: 20,
          _fontWeight: 700,
          _fontFamily: 'poppinsMedium',
          _fill: '#FFFFFF',
          align: 'center',
          _wordWrap: true,
          _wordWrapWidth: 206,
        }}
        resolution={2}
      />
    </Container>
  );
}
export default ReconnectPopup;
